/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Role_In_UseInputs */

const en_adm_err_role_in_use = /** @type {(inputs: Adm_Err_Role_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This role is still in use. Remove its assignments first.`)
};

const de_adm_err_role_in_use = /** @type {(inputs: Adm_Err_Role_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Rolle wird noch verwendet. Entferne zuerst ihre Zuweisungen.`)
};

/**
* | output |
* | --- |
* | "This role is still in use. Remove its assignments first." |
*
* @param {Adm_Err_Role_In_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_role_in_use = /** @type {((inputs?: Adm_Err_Role_In_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Role_In_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_role_in_use(inputs)
	return en_adm_err_role_in_use(inputs)
});